import React, { useState, useEffect, useMemo } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { useAuth } from '../../hooks/auth';
import api, { exceptionNotificationAPI } from '../../services/api';

import getValidationErrors from '../../utils/getValidationErrors';
import { formSelectStyles, formSelectControlFullWidth } from '../../components/FormInput/formSelectStyles';

import { Container, SignInDividerOr } from './styles';

const SignIn = () => {
    const { signIn, user, ssoSignIn, ssoRequestToken } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [password, setPassword] = useState('');
    const [userCultures, setUserCultures] = useState([]);
    const [selectedCulture, setSelectedCulture] = useState('');
    const [userRoles, setUserRoles] = useState([]);
    const [ssoToken, setSSOToken] = useState('');
    const [forgotPasswordClicked, setforgotPasswordClicked] = useState('');
    const [loginStep, setLoginStep] = useState('');


    useEffect(() => {
        if (user) {
            // navigate("/");
            navigate("/signin/MultiFactorAuthentication");
        }
    }, [navigate, user]);

    const handleSubmit = async (cultureIdOverride) => {
        try {
            const schema = Yup.object().shape({
                username: Yup.string()
                    .required('Username is required'),
                password: Yup.string().required('Password is required')
            });

            await schema.validate({ username, password }, {
                abortEarly: false,
            });

            const cultureIdToUse = cultureIdOverride != null ? cultureIdOverride : selectedCulture;

            var result = await signIn({
                username: username,
                password: password,
                cultureId: cultureIdToUse
            });

            if (result.data.response)
                navigate("/signin/MultiFactorAuthentication");
        } catch (error) {
            if (error instanceof Yup.ValidationError) {
                getValidationErrors(error);

                return;
            }

            exceptionNotificationAPI(error);
        }
    };

    const onEnterPress = (e, step) => {
        if (e.key == 'Enter') {
            if (step == 1) {
                continueToRoleSelection()
            }
            else if (step == 2) {
                onContinueToCultureSelection()
            }
        }
    }

    const handleSSOSignIn = async (signInUsername = null, token = null, cultureID = null) => {
        signInUsername = signInUsername || username
        var tokenToUse = token || ssoToken
        var cultureToUse = cultureID || selectedCulture
        var ssoResult = await ssoSignIn(tokenToUse, signInUsername, cultureToUse);
        if (ssoResult.data.response) {
            navigate("/");
        }
    }

    const SSORoleSelection = async () => {
        try {
            var response = await ssoRequestToken();
            var token = response.token;
            setSSOToken(token);
            var uniqueName = response.uniqueName;

            if (token) {
                const result = await api.post('/getAllUserRoles', {
                    'userName': uniqueName
                });

                if (result.data.response) {
                    if (result.data.response.length > 1) {
                        setUserRoles([...result.data.response]);
                        setLoginStep("roleSelection");
                        // document.querySelector("#usernameCard").classList.add("hidden")
                        // document.querySelector("#roleSelectionCard").classList.remove("hidden")
                    }
                    else {
                        var name = result.data.response[0].userName;
                        setSelectedRole(result.data.response[0].role);
                        setUsername(name);
                        onContinueToCultureSelection(name, token);
                        // document.querySelector("#usernameCard").classList.add("hidden")

                    }
                }
            }
        }
        catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const SSOCultureSelection = async (name, token = "") => {
        try {
            

            if (name?.length > 0) {
                const result = await api.post('/getAllUserCultures', {
                    'userName': name
                });

                if (result.data.response) {
                    if (result.data.response.length > 1) {
                        setUserCultures([...result.data.response]);
                        setLoginStep("cultureSelection");
                        // document.querySelector("#usernameCard").classList.add("hidden")
                        // document.querySelector("#roleSelectionCard").classList.remove("hidden")
                    }
                    else {
                        setUserCultures([...result.data.response]);
                        setSelectedCulture(result.data.response[0].cultureID);
                        //setUsername(username);
                        await handleSSOSignIn(name, token || null, result.data.response[0].cultureID);
                    }
                }
            }
        }
        catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const continueToCultureSelection = async (name = null) => {
        try {
            const result = await api.post('/getAllUserCultures', {
                'username': name
            });

            if (result.data.response) {
                if (result.data.response.length > 1) {
                    setUserCultures([...result.data.response]);
                    setLoginStep("cultureSelection");
                    // document.querySelector("#usernameCard").classList.add("hidden")
                    // document.querySelector("#roleSelectionCard").classList.remove("hidden")
                }
                else {
                    setUserCultures([...result.data.response]);
                    setSelectedCulture(result.data.response[0].cultureID);
                    //setUsername(result.data.response[0].userName);
                    // document.querySelector("#usernameCard").classList.add("hidden")
                    handleSubmit(result.data.response[0].cultureID);
                }
            }
        }
        catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const continueToRoleSelection = async () => {
        try {
            const result = await api.post('/getAllUserRoles', {
                'username': userEmail
            });

            if (result.data.response) {
                if (result.data.response.length > 1) {
                    setUserRoles([...result.data.response]);
                    setLoginStep("roleSelection");
                    // document.querySelector("#usernameCard").classList.add("hidden")
                    // document.querySelector("#roleSelectionCard").classList.remove("hidden")
                }
                else {
                    setUserRoles([...result.data.response]);
                    setSelectedRole(result.data.response[0].role);
                    setUsername(result.data.response[0].userName);
                    continueToPassword();

                }
            }
        }
        catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const returnToUsername = async () => {
        setLoginStep("");
        // document.querySelector("#roleSelectionCard").classList.add("hidden")
        // document.querySelector("#usernameCard").classList.remove("hidden")
    }

    const continueToPassword = async () => {
        setLoginStep("password");
        // document.querySelector("#roleSelectionCard").classList.add("hidden")
        // document.querySelector("#passwordCard").classList.remove("hidden")
    }

    const returnToRoleSelection = async () => {
        if (userRoles.length > 1) {
            setLoginStep("roleSelection");
            // document.querySelector("#passwordCard").classList.add("hidden")
            // document.querySelector("#roleSelectionCard").classList.remove("hidden")
        }
        else {
            setLoginStep("");
            // document.querySelector("#passwordCard").classList.add("hidden")
            // document.querySelector("#usernameCard").classList.remove("hidden")
        }
    }

    const roleOptions = useMemo(() => (
        userRoles?.map((userRole) => ({
            value: userRole.userName,
            label: userRole.roleDisplayName + (userRole.company != null ? ' - ' + userRole.company : ''),
        })) ?? []
    ), [userRoles]);

    const selectedRoleOption = useMemo(() => (
        roleOptions.find((opt) => opt.value === selectedRole) ?? null
    ), [roleOptions, selectedRole]);

    const cultureOptions = useMemo(() => (
        userCultures?.map((userCulture) => ({
            value: userCulture.cultureID,
            label: userCulture.cultureDisplayName,
        })) ?? []
    ), [userCultures]);

    const selectedCultureOption = useMemo(() => (
        cultureOptions.find((opt) => String(opt.value) === String(selectedCulture)) ?? null
    ), [cultureOptions, selectedCulture]);

    const onContinueToCultureSelection = (name = "", token = "") => {
        if(name?.length > 0 || username?.length > 0) {
            if (token != "")
                SSOCultureSelection(name || username, token);
            else
                continueToCultureSelection(name || username)
        }
    }

    const onSelectCultureClick = () => {
        if (ssoToken != "")
            handleSSOSignIn();
        else
            handleSubmit();
    }

    const onSelectRoleClick = () => {
        if (ssoToken != "")
            SSOCultureSelection(username);
        else
            continueToPassword();
    }

    const onForgotPasswordClicked = async () => {
        if (!forgotPasswordClicked) {
            try {
                setforgotPasswordClicked(true);
                setLoginStep("forgotPassword");
                const result = await api.post('User/forgotPassword', {
                    'username': username
                });

                if (result.data.response) {
                    //"Email sent to " + userEmail + ". Please follow the password reset process in the e-mail."
                }
            }
            catch (error) {
                exceptionNotificationAPI(error);
            }
        }
    }

    return (
        <Container>
            <div className="main-div container" align="center">
                <div className="card">
                    {loginStep === "" ? <div id="usernameCard" className="card-body">
                        <div className="form-group">
                            <label>
                                E-mail
                            </label>
                            <input className="form-control" id="UserName" name="userName" placeholder="" onChange={(e) => setUserEmail(e.target.value)} required={true} type="text" onKeyPressCapture={(e) => onEnterPress(e, 1)} />
                        </div>
                        <button className="btn" onClick={continueToRoleSelection}>Log in with password</button>
                        <SignInDividerOr aria-hidden="true">
                            <span>or</span>
                        </SignInDividerOr>
                        <button className="btn" onClick={SSORoleSelection}>Log in with SSO (Only BAT Leaf Ops)</button>
                    </div>
                        : loginStep === "roleSelection" ?
                            <div className="card-body">
                                <div className="form-group">
                                    <label>
                                        Select your role for this session
                                    </label>
                                    <div style={{ width: '100%' }}>
                                        <Select
                                            options={roleOptions}
                                            value={selectedRoleOption}
                                            onChange={(newValue) => {
                                                const val = newValue?.value ?? '';
                                                setUsername(val);
                                                setSelectedRole(val);
                                            }}
                                            placeholder="Select a role"
                                            isSearchable
                                            isClearable={false}
                                            styles={{
                                                ...formSelectStyles,
                                                control: (base, state) => ({ ...formSelectControlFullWidth(base, state), textAlign: 'left' }),
                                                singleValue: (base) => ({ ...formSelectStyles.singleValue(base), textAlign: 'left' }),
                                                placeholder: (base) => ({ ...formSelectStyles.placeholder(base), textAlign: 'left' }),
                                                input: (base) => ({ ...formSelectStyles.input(base), textAlign: 'left' }),
                                                option: (base, state) => ({ ...formSelectStyles.option(base, state), textAlign: 'left' }),
                                            }}
                                            classNamePrefix="signin-role-select"
                                        />
                                    </div>
                                </div>

                                <button className="btn mb-4" onClick={onSelectRoleClick}>Continue</button>
                                <button className="btn return-button" onClick={returnToUsername}>Return</button>
                            </div>
                            : loginStep === "password" ?
                                <div className="card-body">
                                    <div className="form-group">
                                        <label>
                                            Password
                                        </label>
                                        <input className="form-control" id="Password" name="password" placeholder="" onChange={(e) => setPassword(e.target.value)} required={true} type="password" onKeyPressCapture={(e) => onEnterPress(e, 2)} />
                                    </div>
                                    <button className="btn mb-4" onClick={() => onContinueToCultureSelection()}>Continue</button>
                                    <button className="btn return-button" onClick={returnToRoleSelection}>Return</button>
                                    <a onClick={onForgotPasswordClicked}>Forgot Password?</a>
                                </div>
                                : loginStep === "cultureSelection" ?
                                    <div className="card-body">
                                        <div className="form-group">
                                            <label>
                                                Select report for this session
                                            </label>
                                            <div style={{ width: '100%' }}>
                                                <Select
                                                    options={cultureOptions}
                                                    value={selectedCultureOption}
                                                    onChange={(newValue) => {
                                                        setSelectedCulture(newValue?.value ?? '');
                                                    }}
                                                    placeholder="Select a Report"
                                                    isSearchable
                                                    isClearable={false}
                                                    styles={{
                                                        ...formSelectStyles,
                                                        control: (base, state) => ({ ...formSelectControlFullWidth(base, state), textAlign: 'left' }),
                                                        singleValue: (base) => ({ ...formSelectStyles.singleValue(base), textAlign: 'left' }),
                                                        placeholder: (base) => ({ ...formSelectStyles.placeholder(base), textAlign: 'left' }),
                                                        input: (base) => ({ ...formSelectStyles.input(base), textAlign: 'left' }),
                                                        option: (base, state) => ({ ...formSelectStyles.option(base, state), textAlign: 'left' }),
                                                    }}
                                                    classNamePrefix="signin-culture-select"
                                                />
                                            </div>
                                        </div>

                                        <button className="btn mb-4" onClick={onSelectCultureClick}>Log in</button>
                                        <button className="btn return-button" onClick={returnToUsername}>Return</button>
                                    </div>
                                    : loginStep === "forgotPassword" ?
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label>
                                                    {"Email sent to " + userEmail + ". Please follow the password reset process in the e-mail."}
                                                </label>
                                            </div>
                                        </div>
                                        : <></>}
                </div>
                <div className="card card-terms mb-2">
                    <div className="terms">
                        <p>Third parties' representatives accessing this tool can learn more about how BAT is processing personal data for business relationships from <a href="https://www.bat.com/group/sites/UK__9D9KCY.nsf/vwPagesWebLive/DOBB5H9Z" target="_blank" rel="noreferrer">here</a></p>
                        <p>BAT employees accessing this tool can learn more about how their personal data is processed by checking the local BAT Employees Privacy Notice where applicable. In case of queries, please contact your local Legal team.</p>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default SignIn;
